import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { IStar } from '@interfaces/star.interface';
import { StarEvent } from '../ui-star/ui-star.component';

@Component({
  selector: 'ark-ui-rating',
  templateUrl: './ui-rating.component.html',
  styleUrls: ['./ui-rating.component.scss'],
})
export class UiRatingComponent {
  @ViewChild('rate', { static: true })
  protected readonly rate!: ElementRef<HTMLElement>;

  @Input()
  public editable = false;

  @Input()
  public size: 'medium' | 'avatar' | 'large' = 'medium';

  @Input()
  public set initialValue(value: number | undefined) {
    if (value) {
      this._value = value * 100;
      this.transferStar();
    }
  }

  @Input()
  public set initialQuantity(value: number) {
    for (let i = 1; i <= value; i++) {
      this.stars.push({
        position: i,
        percent: 0,
      });
    }
    this.transferStar();
  }

  @Output()
  public clickRate: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  public hoverRate: EventEmitter<number> = new EventEmitter<number>();

  public stars: IStar[] = [];
  public on = true;
  public canHover = true;
  public hoverValue = 0;

  protected _value = 0;
  public get value(): number {
    return this._value;
  }

  public hoverOn(): void {
    if (!this.on && this.canHover) {
      this.on = true;
      this.transferStar();
    }
  }

  public hoverOut(): void {
    if (this.on && this.canHover) {
      this.on = false;
      this.transferStar();
    }
  }

  public itemHoverOn(x: number, star: IStar): void {
    if (this.on && this.canHover) {
      x = x > 0 ? x : 0;
      const percent =
        Math.round(parseInt(((x / 19) * 100).toFixed(2), 0) / 5) * 5;
      this.hoverValue = percent + 100 * (star.position - 1);
      this.transferStar();
      this.hoverRate.emit(this.hoverValue / 100);
    }
  }

  public itemHoverOut(): void {
    if (this.on && this.canHover) {
      this.transferStar();
    }
  }

  public itemClick(): void {
    if (!this.editable) return;
    if (this.canHover) {
      this._value = this.hoverValue;
      this.transferStar();
      this.clickRate.emit(this.value / 100);
    }
  }

  public itemClickOn(event: StarEvent): void {
    if (!this.editable) return;
    this.hoverValue = event.star.position * 100;
    this.transferStar();
    this.hoverRate.emit(this.hoverValue);
  }

  public transferStar(): void {
    const value = this._value;
    this.stars.forEach((e) => {
      const val = (e.position - 1) * 100;
      if (value - val > 0) {
        e.percent = value - val < 100 ? value - val : 100;
      } else {
        e.percent = 0;
      }
    });
  }

  @HostListener('document:click', ['$event.target'])
  public onClick(target: HTMLElement): void {
    if (this.editable) {
      const contains = this.rate.nativeElement.contains(target);
      if (contains) {
        this.canHover = !this.canHover;
      } else {
        this.canHover = false;
      }
    }
  }
}
